import { Component } from '@angular/core';

@Component({
  selector: 'mafo5-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent {

}
